import { useQuery } from '@tanstack/react-query';
import { getLastBuild, isBuildInFlight, type LastBuild } from '../services/buildOrchestration.service';
import { useIsInDraftMode } from './useDraftMode';

/** How often we re-ask while a build is actually running. */
const IN_FLIGHT_POLL_MS = 15_000;

/**
 * When the data on the branch the user is reading was last built.
 *
 * Keyed by mode because the answer differs per branch: a cached production
 * timestamp must not be handed back after a switch into develop mode.
 */
export function useLastBuild() {
  const isInDraftMode = useIsInDraftMode();

  return useQuery<LastBuild>({
    queryKey: ['last-build', isInDraftMode ? 'DRAFT' : 'PROD'],
    queryFn: getLastBuild,
    staleTime: 60 * 1000,
    refetchInterval: (query) =>
      isBuildInFlight(query.state.data?.latest_build) ? IN_FLIGHT_POLL_MS : false,
  });
}
